<template>
  <DefButtonPrimary
    class="def-buy"
    :class="{ 'in-basket': inBasket(id), 'def-buy-small': !$slots?.default }"
    :disabled="disabled || isRequestSend"
    @click="handlerBuy"
  >
    <!-- product in basket -->
    <svg v-if="inBasket(id)" class="def-buy__icon"><use xlink:href="#svg-check"></use></svg>
    <svg v-else class="def-buy__icon"><use xlink:href="#svg-basket"></use></svg>

    <slot v-if="inBasket(id)" name="inBasket" />
    <!-- add product to basket -->
    <slot v-else />
  </DefButtonPrimary>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import anime from 'animejs';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import useBasketState from '@use/useBasketState';

import Analytics from '@/utils/Analytics';

export default {
  name: 'DefBuy',
  components: {
    DefButtonPrimary,
  },
  props: {
    result: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      isRequestSend: false,
      modal: useModal(),
      basketState: useBasketState(),
    };
  },
  computed: {
    ...mapState({
      createOrder: ({ basket }) => basket.data?.routes?.createOrder,
    }),
    ...mapGetters({
      inBasket: 'basket/inBasket',
    }),
    id() {
      return this.result?.offer?.id || this.result?.id;
    },
  },
  methods: {
    ...mapActions({
      add: 'basket/add',
    }),
    createAnimation() {
      try {
        const div = document.createElement('div');
        div.classList.add('buy-animation');
        div.style.backgroundImage = `url(${this.result.picture.src})`;
        div.style.zIndex = 2001;

        const baskets = document.querySelectorAll('.small-basket-control');

        if (!baskets.length) return;

        const smallBasket = baskets.length === 2 ? baskets[1] : baskets[0];
        const rect = smallBasket.getBoundingClientRect();

        document.body.appendChild(div);

        anime({
          targets: div,
          duration: 2000,
          keyframes: [
            {
              top: innerHeight / 2,
              width: 100,
              height: 100,
              translateX: '-50%',
              translateY: '-100%',
              left: innerWidth / 2,
              easing: 'easeInQuad',
            },
            {
              top: rect.top,
              left: rect.left,
              width: 50,
              height: 50,
              easing: 'linear',
              border: 1,
              translateY: '-20%',
              translateX: '-20%',
            },
          ],
          complete() {
            div.remove();
          },
        });
      } catch (err) {
        console.error(err);
      }
    },
    async handlerBuy() {
      if (!this.inBasket(this.id)) {
        this.isRequestSend = true;
        this.createAnimation();
        await this.add({ id: this.id, count: this.result?.price?.quantity });
        Analytics.addToBasket(this.result);
        App.helpers.scrollPageTo(0);
        this.isRequestSend = false;
      } else {
        await this.modal.hide();
        this.basketState.open();
      }
    },
  },
  mounted() {
    // console.log();
    // setTimeout(this.createAnimation,1000)
  },
};
</script>

<style lang="scss" scoped>
.def-buy {
  display: flex;
  gap: 4px;
  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    fill: currentColor;
    flex-shrink: 0;
  }
  //&:disabled {
  //  fill: #c0c0c0;
  //}
}
.def-buy-small {
  padding: 0 8px;
  height: 40px;
  min-width: 40px;
}
</style>
